export default __webpack_public_path__ + "static/media/video.77304306.mp4";